.buttonGroup {
  display: inline-flex;
  border-radius: var(--tuna-shape-borderRadius);
}

.vertical {
  flex-direction: column;
}
